import { ApolloClient, InMemoryCache } from '@apollo/client'
import type { ApolloLink } from '@apollo/client'
import { createUploadLink } from 'apollo-upload-client'

import { config } from '~/common/config/config'

const uploadLink = createUploadLink({
  uri: config.graphqlApiUrl,
  headers: { 'Apollo-Require-Preflight': 'true' },
  credentials: 'include', // Send sealed session cookie with every request (WorkOS auth)
})

export const apolloClient = new ApolloClient({
  link: uploadLink as unknown as ApolloLink,
  cache: new InMemoryCache({
    typePolicies: {
      // Add cache policies here as needed during migration
    },
  }),
})
